import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledApplovinBundle = styled.div`
  --border-radius: ${(props: any) => `${props.borderRadius || 15}px`};
  height: 200px;
  margin: 0 auto;
  border-radius: var(--border-radius);
  padding: 3px;
  background: ${(props: any) => createGradientOrSolid(props.bundleBorderColor)};
  font-family: ${(props: any) => props.fontFamily};
  position: relative;

  .container {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: var(--border-radius);
    background: linear-gradient(180deg, #e55ef5 0%, #d644f5 100%);
    align-items: center;
    justify-content: center;

    .apl-bundle-price {
      position: relative;
      top: -10px;

      .stroked {
        text-decoration-line: line-through;
        text-decoration-color: #d8232a;
        text-decoration-thickness: 1px;
        margin-right: ${(props: any) => props.direction === 'rtl' ? '0' : '10px'};
        margin-left: ${(props: any) => props.direction === 'rtl' ? '10px' : '0'};      
        display: flex;
        align-items: center;
        font-size: 12px;
      }
    }
  }

  .scroller {
    right: 0;
    bottom: 0;
    height: calc(100% - 72px);
    box-shadow: inset -26px 0px 16px -10px #4b107e;
    width: 50px;
    position: absolute;
    z-index: 10000;

    > button {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      border: 0;
      position: absolute;
      background: #dc4cf3;
      box-shadow: 0px 2px 3px 0px #0b4969;
      left: 35px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .products {
    min-height: calc(100% - 30px);
    border-top-left-radius: ${(props: any) => `${props.borderRadius || 15}px`};
    border-top-right-radius: ${(props: any) => `${props.borderRadius || 15}px`};
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    width: 100%;

    & > div:not(.scroller) {
      width: 90%;

      &.sub {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        position: relative;
        padding: 4px;
      }
    }
  }

  .sub-items-grid {
    height: 100px;
    border: 7px solid #4b0e7e;
    overflow-x: hidden;
    background: #4b0e7e;
    width: 90%;
    border-radius: var(--border-radius);
    display: grid;
    grid-template-rows: 50% 50%;
    grid-auto-flow: column;
    column-gap: 8px;
    box-shadow: inset 0 0 10px #4b0e7e;

    .sub-items__arrow {
      position: absolute;
      right: 14px;
      top: 64%;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 0;
      background: #dc4cf3;
      display: flex;
      justify-content: center;
      align-items: center;
      filter: drop-shadow(0px 1px 1px #000);
      padding: 1px;

      &:hover {
        cursor: pointer;
      }
    }

    > div {
      display: flex;
      width: max-content;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin: 0;
    }
  }

  span {
    text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.8);
    color: ${(props: any) => props.textColor};

    &.availability {
      position: absolute;
      bottom: 10px;
      font-size: 12px;
      font-weight: 600;

      &.quantity {
        left: 15px;
      }
    }
  }
` as any;

export const StyledMainProduct = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    object-fit: contain;

    &.mainPic {
      height: 62px;
      width: 62px;
      position: relative;
    }

    &.prefixPic {
      height: 18px;
      width: 18px;
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 25%;
    margin-left: 8px;
    position: relative;
    z-index: 1;

    p {
      margin: 0;
      text-align: center;

      &.quantity {
        font-size: 16px;
        font-weight: 900;
        background: linear-gradient(180deg, #f7fe76 53.12%, #f1b443 67.71%);
        background-clip: text;
        -webkit-background-clip: text;
        -moz-background-clip: text;
        -moz-text-fill-color: transparent;
        -webkit-text-fill-color: transparent;
        position: relative;

        &:after {
          background: none;
          content: '${(props: any) => props.title}';
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.8);
        }
      }

      &.stroked {
        color: white;
        position: relative;
        text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.8);
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        text-decoration: line-through #d8232a;
        text-underline-offset: 2px;
      }
    }
  }

  @media (min-width: 375px) {
    img {
      &.mainPic {
        transform: scale(1.2);
      }

      &.prefixPic {
        height: 22px;
        width: 22px;
      }
    }

    .text {
      margin-left: 8px;

      .quantity-container {
        margin-left: 6px;
      }

      p {
        &.quantity {
          font-size: 30px;
        }

        &.stroked {
          font-size: 14px;
        }
      }
    }
  }
` as any;

export const StyledSubProduct = styled.div`
  margin-right: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;

  .content-container {
    display: flex;
    align-items: center;

    p {
      font-size: 16px;
      font-weight: 700;
      color: ${(props: any) => props.color};
      margin: unset;

      &.tooltip {
        font-size: 12px;
        font-weight: 400;

        img {
          height: 8px;
        }
      }
    }
  }

  img {
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  .product-image-container {
    position: relative;
    padding: 0 4px;
    height: 28px;
    display: flex;
    flex-direction: row;

    .product {
      height: 100%;
      position: relative;
      z-index: 2;
    }

    .badge {
      height: 22px;
      width: 40px;
      display: flex;
      align-items: center;
      position: relative;
      top: 20px;
      right: -15px;
      z-index: 1;
      transform: translateY(-50%);
      background-image: url('https://media.appcharge.com/defaults/product-badge-huge.png');
      background-size: cover;

      h4 {
        position: relative;
        font-size: 14px;
        padding-left: 8px;
        font-weight: 600;
        background: -webkit-linear-gradient(
          rgb(255, 247, 199),
          rgb(226, 182, 109)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        &:after {
          background: none;
          content: '${(props: any) => props.badgeText}';
          padding-left: 8px;
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 0 1px 0px #000000;
        }
      }
    }

    .tooltip {
      height: 8px;
      width: 8px;
      position: absolute;
      top: 10px;
      left: 4px;
      transform: translateY(-100%);
      z-index: 4;
    }
  }

  @media (min-width: 375px) {
    .product-image-container .tooltip {
      height: 10px;
      width: 10px;
    }
  }
` as any;
